import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import { FiCheckCircle, FiZap, FiTarget, FiBox } from 'react-icons/fi';
import { CTAButton } from '../ui/CTAButton';
import { CountdownTimer } from '../ui/CountdownTimer';

export const Hero = () => {
  const trustBullets = [
    { text: "Lifetime Access", icon: FiCheckCircle },
    { text: "Step-by-Step System", icon: FiZap },
    { text: "Weekly Coaching", icon: FiTarget },
    { text: "Community Support", icon: FiCheckCircle },
    { text: "Bonus FunnelsDone Plan", icon: FiBox },
    { text: "Vibe Coding Included", icon: FiZap },
  ];

  return (
    <section className="relative min-h-[90vh] flex flex-col items-center justify-center pt-24 pb-16 px-4 overflow-hidden bg-hero-glow">
      {/* Background Elements */}
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-royal-600/20 rounded-full blur-[120px] -z-10 mix-blend-screen"></div>
      <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-gold-500/10 rounded-full blur-[120px] -z-10 mix-blend-screen"></div>

      <div className="max-w-5xl mx-auto text-center w-full z-10">
        <motion.div 
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-red-500/10 border border-red-500/30 text-red-400 font-semibold text-sm mb-8"
        >
          <span className="animate-pulse">🔥</span> Financial Year End Special
        </motion.div>

        <motion.h1 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-white tracking-tight leading-tight mb-6"
        >
          Save <span className="text-royal-400">₹12,000</span> Today & Get <span className="text-transparent bg-clip-text bg-gradient-to-r from-gold-300 to-gold-500">Lifetime FREE</span> Access to Digital Millionaires Community
        </motion.h1>

        <motion.p 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="text-xl md:text-3xl text-white font-bold max-w-3xl mx-auto mb-6 leading-relaxed"
        >
          Upgrade to Silver 2.0 for Just <span className="text-gold-400">₹3,997</span> — <span className="line-through text-gray-500 text-xl font-normal">Normally ₹16,000 + GST</span>
        </motion.p>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
          className="text-lg text-gray-300 max-w-2xl mx-auto mb-10"
        >
          Build Your ₹1 Lakh/Month Online Income System with Step-by-Step Guidance, Weekly Coaching, and a Proven Community.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.4 }}
          className="flex flex-col items-center gap-4 mb-12"
        >
          <CTAButton text="Upgrade Now" className="w-full sm:w-auto min-w-[280px]" />
          <p className="text-sm text-gray-400 mt-2">Offer valid only till 31st March 2026</p>
        </motion.div>

        <CountdownTimer />

        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5 }}
          className="mt-12 grid grid-cols-2 md:grid-cols-3 gap-y-4 gap-x-6 max-w-3xl mx-auto text-left"
        >
          {trustBullets.map((bullet, idx) => (
            <div key={idx} className="flex items-center gap-2 text-gray-300 text-sm md:text-base">
              <SafeIcon icon={bullet.icon} className="text-royal-500 shrink-0" />
              <span>{bullet.text}</span>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};